import { put, take, call, fork, cancel, select } from 'redux-saga/effects';
import { takeLatest, takeEvery, delay } from 'redux-saga';

import * as actions from 'actions';
import * as api from 'api';
import queries, { normalizeMagazineQuery } from 'magazineQueries';
import { optimisticUpdateMaker } from 'utils/sagas';
import { getMagazinePaging } from 'selectors';

export function* watchForMagazineQueryChange() {
  let task;

  while(true) { // eslint-disable-line no-constant-condition
    const { payload } = yield take('@@router/LOCATION_CHANGE');

    const isArticlesList = ['/magazine', '/magazine/'].indexOf(payload.pathname) >= 0;
    const isArticleProfile = payload.pathname.indexOf('/magazine/articles/') === 0;

    if(isArticlesList || isArticleProfile) {
      if(task) {
        yield cancel(task);
      }

      let queryString = null;

      if(isArticlesList) {
        const query = normalizeMagazineQuery(payload.query);
        queryString = JSON.stringify(query);

        let page = 1;

        if(payload.action === 'POP') {
          const paging = yield select(getMagazinePaging, 'magazineArticles', { queryString });
          page = paging.page;
        }

        yield put(actions.magazineArticlesFetch(page, query, queryString));
      }

      task = yield fork(loadSidePanel, queryString);
    }
  }
}

function *loadSidePanel(currentQueryString) {
  yield call(delay, 1000);

  const queriesKeys = Object.keys(queries);
  const otherFetches = [];
  const maxOtherQueriesToMake = 2;

  for(let i = 0; i < queriesKeys.length; i++) {
    const query = queries[queriesKeys[i]].query;
    const queryString = JSON.stringify(query);

    if(otherFetches.length < maxOtherQueriesToMake && queryString !== currentQueryString) {
      otherFetches.push(put(actions.magazineSidebarArticlesFetch(1, query, queryString)));
    }
  }

  yield otherFetches;
}

export function* watchForSuccessfullyCreatedArticle() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.MAGAZINE_ARTICLE_CREATE_SUCCESS);
    yield put(actions.magazineContributeEditingReset());
    yield put(actions.infoShow('success', action.successMessage));
  }
}

const follow = optimisticUpdateMaker({
  idKey: 'magazineArticleId',
  localUpdateType: actions.MAGAZINE_ARTICLE_UPDATE,
  successType: actions.MAGAZINE_ARTICLE_FOLLOW_SUCCESS,
  errorType: actions.MAGAZINE_ARTICLE_FOLLOW_ERROR,
  remoteUpdateActionCreator: function* (localUpdateAction) {
    if(localUpdateAction.updates.followed !== undefined) {
      return actions.magazineArticleFollow(localUpdateAction.magazineArticleId, localUpdateAction.updates.followed);
    }
  },
  localUpdateActionCreator: function* (lastRemoteState, errorAction) {
    return actions.magazineArticleUpdate(errorAction.magazineArticleId, null, lastRemoteState);
  }
});

const favourite = optimisticUpdateMaker({
  idKey: 'magazineArticleId',
  localUpdateType: actions.MAGAZINE_ARTICLE_UPDATE,
  successType: actions.MAGAZINE_ARTICLE_FAVOURITE_SUCCESS,
  errorType: actions.MAGAZINE_ARTICLE_FAVOURITE_ERROR,
  remoteUpdateActionCreator: function* (localUpdateAction) {
    if(localUpdateAction.updates.favourite !== undefined) {
      return actions.magazineArticleFavourite(localUpdateAction.magazineArticleId, localUpdateAction.updates.favourite);
    }
  },
  localUpdateActionCreator: function* (lastRemoteState, errorAction) {
    return actions.magazineArticleUpdate(errorAction.magazineArticleId, null, lastRemoteState);
  }
});

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.MAGAZINE_ARTICLE_CREATE, request(api.magazineArticleCreate, 'title', 'text')),
    fork(takeLatest, actions.MAGAZINE_ARTICLE_FOLLOW, request(api.magazineArticleFollow, 'magazineArticleId', 'followed')),
    fork(takeLatest, actions.MAGAZINE_ARTICLE_FAVOURITE, request(api.magazineArticleFavourite, 'magazineArticleId', 'favourite')),
    fork(takeLatest, actions.MAGAZINE_ARTICLES_FETCH, request(api.magazineArticlesFetch, 'page', 'query')),
    fork(takeEvery, actions.MAGAZINE_SIDEBAR_ARTICLES_FETCH, request(api.magazineArticlesFetch, 'page', 'query')),
    fork(takeLatest, actions.MAGAZINE_ARTICLE_PROFILE_FETCH, request(api.magazineArticleProfileFetch, 'magazineArticleId')),
    fork(watchForMagazineQueryChange),
    fork(watchForSuccessfullyCreatedArticle),
    fork(favourite),
    fork(follow)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/sagas.js
 **/